import { agencyFieldVariant, fieldVariantKey, toIntakeField, variantOf } from './variants.js';
/** The registry's stored ways as variantOf reads them. */
const storedWays = (reg) => (reg?.variant ? (key) => reg.variant(key) : undefined);
/** The key a form field asks (the form coverage gate, the key map): its `question_key`, else what its id reads as. */
export function formItemKey(field, keyOf) {
    return field.question_key ?? keyOf(field.id) ?? null;
}
/**
 * Whether a field is a library item that names a way to ask its question (a code way, the label, or a stored way), which
 * a save stores the item as (the way's complete field; the server's lib/library/forms.ts). False for a legacy field and
 * for an item whose way is the field itself (`f:<id>`, or no variant key): the agency's own wording of the question.
 */
export function namesWay(field) {
    return !!field.question_key && !!field.variant_key && field.variant_key !== fieldVariantKey(field.id);
}
/**
 * The way a field asks `q`, which its answers are converted through (answerToValue, valueToAnswer): a library
 * item's own way when its `variant_key` names one of `q` (variantOf); the field itself as the agency's own way
 * (agencyFieldVariant) for a legacy field, or an item whose way is the field (`f:<id>`, or no variant key); null for
 * an item of `q` whose named way is gone (retired, or another agency's), whose answers must not be converted.
 */
export function fieldVariant(q, field, reg) {
    const named = field.question_key === q.key && namesWay(field);
    if (!named)
        return agencyFieldVariant(q, field);
    return variantOf(q, field.variant_key, storedWays(reg)) ?? null;
}
/**
 * A form's stored fields as a runner shows them (spec 3.20; intake run, portal, walkthrough, submission display,
 * whatever LIBRARY_PICKER says): each library item with its wording (label and help) refreshed from its way, the
 * agency's required flag and reason and every other property kept as stored; legacy fields unchanged; an item whose
 * question or way no longer resolves exactly as stored, never dropped.
 */
export function resolveFormFields(fields, reg) {
    return fields.map((field) => {
        const q = field.question_key ? reg.question(field.question_key) : undefined;
        const v = q ? variantOf(q, field.variant_key, storedWays(reg)) : undefined;
        if (!q || !v)
            return field;
        const fresh = toIntakeField(q, v, field.id);
        const shown = { ...field, label: fresh.label };
        if (fresh.help)
            shown.help = fresh.help;
        else
            delete shown.help;
        return shown;
    });
}
//# sourceMappingURL=forms.js.map